import React, { useEffect, useRef, useState } from 'react';
import AOS from 'aos'; // AOS 스크립트 파일을 임포트
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCreative, EffectFade } from 'swiper/modules'; // 필요한 모듈
import heroImage from '../../assets/imgs/heroImg1.webp';
import heroImage2 from '../../assets/imgs/heroImg2.webp';
import heroImage3 from '../../assets/imgs/heroImg3.webp';
import portfolioImg1 from '../../assets/imgs/portfolioImg1.jpg';
import portfolioImg2 from '../../assets/imgs/portfolioImg2.jpg';
import portfolioImg3 from '../../assets/imgs/portfolioImg3.jpg';
import deliveryLogo from '../../assets/imgs/deliveryLogo.png';
import kisaLogo from '../../assets/imgs/kisaLogo.png';
import bannerImg from '../../assets/imgs/bannerImg.jpg';
import cloudImg from '../../assets/imgs/cloudsettingimg.png';
import cdnImg from '../../assets/imgs/cdnimg.png';
import corocationImg from '../../assets/imgs/colocationimg.png';
import mainSloItem1 from '../../assets/imgs/mainsloItem1.jpg';
import mainSloItem2 from '../../assets/imgs/mainsloItem2.jpg';
import mainSloItem3 from '../../assets/imgs/mainsloItem3.jpg';
import mainSloItem4 from '../../assets/imgs/mainsloItem4.jpg';
import mainSloItem5 from '../../assets/imgs/mainsloItem5.jpg';
import mainSloItem6 from '../../assets/imgs/mainsloItem6.jpg';
import hostingImg from '../../assets/imgs/serverhostingimg.png';
import TransparentBtn from '../../components/global/TransparentBtn';
import { Link } from 'react-router-dom';
import useMediaQuery from '../hook/useMediaQuery';
import useSwiperProgress from '../hook/useSwiperProgress';
import AnimatedIcon from '../../components/global/AnimatedIcon';

const sloganItem = [
  {
    icon: '',
    img: mainSloItem1,
    title: '클라우드 인프라 구축 및 운영',
    mainDescription: '맞춤형 클라우드 환경 설계부터 안정적인 운영까지',
    subDescription:
      '고객의 서비스구조와 요구사항에 최적화된 클라우드 아키텍처를 설계하고, 유연한 확장성과 안정적인 운영을 지원 합니다.',
    link: '/',
  },
  {
    icon: '',
    img: mainSloItem2,
    title: '안정적인 IDC 환경 제공',
    mainDescription: 'SK, KT, LG 등 다양한 회선 연동으로 네트워크 안정성 확보',
    subDescription:
      '고성능 장비와 최적화된 냉각·전력 시스템을 기반으로, 안정적인 비즈니스 인프라 운영을 보장 합니다.',
    link: '/',
  },
  {
    icon: '',
    img: mainSloItem3,
    title: '멀티 ISP 기반 IDC 환경',
    mainDescription: '전문 엔지니어 상주 및 실시간 관제로 안정적인 서비스 운영',
    subDescription:
      '통신사 이중화를 통해 장애 대응력을 높이고, 트래픽 상황에 따라 유연한 대응이 가능합니다.',
    link: '/',
  },
  {
    icon: '',
    img: mainSloItem4,
    title: '24/7 무중단 운영 지원 ',
    mainDescription: '전문 엔지니어 상주 및 실시간 관제로 안정적인 서비스 운영',
    subDescription:
      '실시간 모니터링과 장애 대응 체계를 통해 고객 서비스의 연속성을 보장합니다.',
    link: '/',
  },
  {
    icon: '',
    img: mainSloItem5,
    title: '맞춤형 서버/랙 구성 제공',
    mainDescription: '비즈니스 규모에 따라 서버호스팅, 코로케이션 모두 지원',
    subDescription:
      '필요한 스펙과 용도에 맞춘 전용 공간 설계와 유연한 인프라 구성이 가능합니다.',
    link: '/',
  },
  {
    icon: '',
    img: mainSloItem6,
    title: '보안 및 이중화 설비 강화',
    mainDescription: '철저한 물리적 보안과 전력·네트워크 이중화 시스템 구축',
    subDescription:
      '재해 복구 및 백업 체계까지 포함한 고신뢰 IDC 환경을 제공 합니다.',
    link: '/',
  },
];
function Main({ firstSectionRef }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null);
  const [progress, setProgress] = useState(0); // 게이지 진행 상태
  const [isPaused, setIsPaused] = useState(false); // 일시 정지 여부
  const intervalRef = useRef(null);
  const autoplayDelay = 3000; // 오토플레이 시간 (ms)
  const goToSlide = (index) => {
    if (swiperRef.current) {
      swiperRef.current.slideToLoop(index, 1200); // ✅ loop 모드에서도 정확한 슬라이드로 이동
    }
  };

  useEffect(() => {
    const images = [heroImage, heroImage2, heroImage3];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);
  // 게이지 애니메이션 핸들링
  const startProgress = () => {
    setIsPaused(false);
    setProgress(0);
    intervalRef.current = setInterval(() => {
      setProgress((prev) => Math.min(prev + 100 / (autoplayDelay / 100), 100)); // 100ms마다 증가
    }, 100);
  };

  useEffect(() => {
    startProgress(); // 초기 시작
    return () => clearInterval(intervalRef.current); // 컴포넌트 언마운트 시 정리
  }, [activeIndex]); // activeIndex 변경될 때마다 진행바 초기화

  const ourServiceSwiperRef = useRef(null);
  const [ourServiceActiveIndex, setOurServiceActiveIndex] = useState(0);
  const goToSlideForOurService = (index) => {
    if (ourServiceSwiperRef.current) {
      ourServiceSwiperRef.current.slideToLoop(index, 1200); // ✅ loop 모드에서도 정확한 슬라이드로 이동
    }
  };

  const [portfolioActiveIndex, setPortfolioActiveIndex] = useState(1);

  const sloganSwiper = useRef(null);
  const [sloganActiveIndex, setSloganActiveIndex] = useState(0);
  const goToSlideForSlogan = (index) => {
    if (sloganSwiper.current) {
      sloganSwiper.current.slideToLoop(index, 1200); // ✅ loop 모드에서도 정확한 슬라이드로 이동
    }
  };
  useEffect(() => {
    AOS.init({
      duration: 1000, // 애니메이션 지속 시간 (ms)
      easing: 'ease-out', // 애니메이션 이징 함수
      once: false, // 스크롤 후 한 번만 애니메이션 실행
    });
  }, []);

  const [slidesPerView, setSlidesPerView] = useState(
    window.innerWidth > 959 ? 3 : 1,
  );

  useEffect(() => {
    const updateSlidesPerView = () => {
      setSlidesPerView(window.innerWidth > 959 ? 3 : 1);
    };

    window.addEventListener('resize', updateSlidesPerView);

    return () => window.removeEventListener('resize', updateSlidesPerView);
  }, []);
  const isDesktop = useMediaQuery('(min-width: 961px)');

  const [perGroup, setPerGroup] = useState(1); // Swiper의 slidesPerGroup 값

  const {
    progressPercent: ourServiceProgressPercent,
    tooltipPercent: ourServiceTooltipPercent,
    tooltipVisible: ourServiceTooltipVisible,
    handleMouseMove: ourServiceHandleSloganMouseMove,
    handleMouseLeave: ourServiceHandleSloganMouseLeave,
    handleClick: ourServiceHandleSloganClick,
  } = useSwiperProgress(ourServiceSwiperRef, ourServiceActiveIndex, perGroup);
  return (
    <div className={`mainPageWrapper`}>
      <div
        data-aos="fade"
        data-aos-delay="0"
        data-aos-offset="0"
        ref={firstSectionRef}
        className="heroSection flex-row justify-center"
      >
        <div className="swiperWrapper h-full">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            className={'heroSliderCustom'}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            slidesPerView={1}
            modules={[EffectCreative, Autoplay]}
            effect="creative"
            touchReleaseOnEdges={false}
            speed={1200}
            spaceBetween={0}
            loop={true}
            autoplay={{
              delay: 3000,
            }}
            creativeEffect={{
              prev: {
                shadow: true,
                translate: ['-80%', 0, 0],
              },
              next: {
                translate: ['100%', 0, 0],
              },
            }}
          >
            <SwiperSlide
              className={'heroSliderCustomItem flex-row justify-center'}
            >
              <div className="heroSliderItem ">
                <div className="heroSliderItemImg">
                  <img src={heroImage} alt="" />
                </div>
                <div className="grid">
                  <div className="heroSliderItemText flex-col gap-48 justify-start">
                    <div className="flex-col  gap-64">
                      <div className="flex-col gap-48 ">
                        <div className="flex-col gap-20 ">
                          <div className="subOneText ">
                            <span>강력한 CSP 파트너십</span>
                          </div>
                          <div className="mainText">
                            <span>
                              NHN클라우드 플래티넘 파트너
                              <br />
                              완벽한 Managed 서비스
                            </span>
                          </div>
                        </div>
                        <div className="description">
                          <span>
                            클라우드가 필요하신가요?
                            <br />
                            디엔에이클라우드가 도와드리겠습니다
                          </span>
                        </div>
                      </div>

                      <TransparentBtn to={'/contact'} text={'문의하기'} />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className={'heroSliderCustomItem flex-row justify-center'}
            >
              <div className="heroSliderItem ">
                <div className="heroSliderItemImg">
                  <img src={heroImage2} alt="" />
                </div>
                <div className="grid">
                  <div className="heroSliderItemText flex-col gap-48 justify-start">
                    <div className="flex-col  gap-64">
                      <div className="flex-col gap-48 ">
                        <div className="flex-col gap-20 ">
                          <div className="subOneText ">
                            <span>신규서비스 오픈과 CSP 전환</span>
                          </div>
                          <div className="mainText">
                            <span>
                              신규 서비스 오픈과 함께
                              <br />
                              NHN클라우드 기반 <br /> CSP 전환 성공
                            </span>
                          </div>
                        </div>
                        <div className="description">
                          <span>
                            디앤에이클라우드의 신규서비스 오픈
                            <br />
                            새로운 패러다임의 전환
                          </span>
                        </div>
                      </div>
                      <TransparentBtn to={'/contact'} text={'문의하기'} />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide
              className={'heroSliderCustomItem flex-row justify-center'}
            >
              <div className="heroSliderItem ">
                <div className="heroSliderItemImg">
                  <img src={heroImage3} alt="" />
                </div>
                <div className="grid">
                  <div className="heroSliderItemText flex-col gap-48 justify-start">
                    <div className="flex-col  gap-64">
                      <div className="flex-col gap-48 ">
                        <div className="flex-col gap-20 ">
                          <div className="subOneText ">
                            <span>안정적인 IDC 서비스 제공</span>
                          </div>
                          <div className="mainText">
                            <span>
                              다양한 ISP 기반,
                              <br />
                              안정적인 IDC 서비스 제공
                            </span>
                          </div>
                        </div>
                        <div className="description">
                          <span>신뢰할 수 있는 LG · KT · SK 통신망 사용</span>
                        </div>
                      </div>
                      <TransparentBtn to={'/contact'} text={'문의하기'} />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div className="mainIndicaterWrap  flex-col justify-center align-center px-40">
            <div className="grid ">
              <div className="mainIndicater flex-row gap-8">
                <div className="stickWrap flex-row gap-8">
                  <div
                    onClick={() => goToSlide(0)}
                    className={`stick ${activeIndex === 0 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlide(1)}
                    className={`stick ${activeIndex === 1 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlide(2)}
                    className={`stick ${activeIndex === 2 ? 'active' : ''}`}
                  ></div>
                </div>
                <div className="icon"></div>
              </div>
            </div>
          </div>
          <div className="swiperNav">
            <div className="flex-col gap-8">
              <div
                onClick={() => goToSlide(0)}
                className="flex-row gap-8 swiperNavBtn"
              >
                <div
                  className={`subIndicater ${activeIndex === 0 ? 'active' : ''}`}
                >
                  <div
                    className="gage"
                    style={{
                      width: activeIndex === 0 ? `${progress}%` : '0%',
                    }}
                  ></div>
                </div>
                <span>NHN클라우드 플래티넘 파트너</span>
              </div>
            </div>
            <div className="flex-col gap-8">
              <div
                onClick={() => goToSlide(1)}
                className="flex-row gap-8 swiperNavBtn"
              >
                <div
                  className={`subIndicater ${activeIndex === 1 ? 'active' : ''}`}
                >
                  <div
                    className="gage"
                    style={{
                      width: activeIndex === 1 ? `${progress}%` : '0%',
                    }}
                  ></div>
                </div>
                <span>클라우드 전환의 새로운 기준</span>
              </div>
            </div>
            <div className="flex-col gap-8">
              <div
                onClick={() => goToSlide(2)}
                className="flex-row gap-8 swiperNavBtn"
              >
                <div
                  className={`subIndicater ${activeIndex === 2 ? 'active' : ''}`}
                >
                  <div
                    className="gage"
                    style={{
                      width: activeIndex === 2 ? `${progress}%` : '0%',
                    }}
                  ></div>
                </div>
                <span>IDC서비스 제공</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="ourServiceSection   flex-col justify-center align-center py-128 tab:py-56"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>OUR SERVICE</span>
            </div>
            <div className="title">
              <span>전문화된 디엔에이클라우드의 서비스를 만나보세요</span>
            </div>
          </div>
          <div className="contentsWrap flex-row gap-80 justify-between">
            <Swiper
              key={isDesktop ? 'desktop' : 'mobile'} // ← 이 부분 중요!
              onSwiper={(swiper) => (ourServiceSwiperRef.current = swiper)}
              className={'ourServiceSwiper'}
              onSlideChange={(swiper) =>
                setOurServiceActiveIndex(swiper.realIndex)
              }
              slidesPerView={1}
              modules={isDesktop ? [EffectFade] : []}
              effect={isDesktop ? 'fade' : undefined}
              fadeEffect={isDesktop ? { crossFade: true } : undefined}
              touchReleaseOnEdges={false}
              speed={isDesktop ? 0 : 500}
              centeredSlides={isDesktop ? false : true}
              spaceBetween={isDesktop ? 0 : 8}
              loop={true}
            >
              <SwiperSlide className={'flex-col gap-20 '}>
                <div className={'flex-col gap-20 '}>
                  <div
                    className={`flex-row gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 0 ? 'active' : ''}`}
                  >
                    <div className="flex-row gap-8">
                      <div className="icon-40">
                        <AnimatedIcon
                          type={'cloud'}
                          active={ourServiceActiveIndex === 0}
                        />
                      </div>
                      <div className="btnText flex-col gap-8 justify-center">
                        <div className="main">
                          <span>클라우드 설계 구축 및 이관</span>
                        </div>
                        <div className="sub">
                          <span>
                            Cloud Architecture Design,
                            <br />
                            Deployment, and Migration
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="numText">
                      <span>01</span>
                    </div>
                  </div>
                  <div className="contentImgWrap">
                    <img src={cloudImg} alt="" />
                    {/*<div className="moreBtn">*/}
                    {/*  <span>VIEW MORE</span>*/}
                    {/*</div>*/}
                    <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                      <div className="textWrap">
                        <span>01</span>
                      </div>
                      <div className="arcSvg positionLB">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="arcSvg positionRT">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="contentTextWrap pl-12 flex-col gap-16">
                    <div className="title">
                      <span>클라우드 설계 구축 및 이관</span>
                    </div>
                    <div className="description">
                      <span>
                        디엔에이클라우드는 고객의 비즈니스 목표에 맞춰 맞춤형
                        클라우드 아키텍처를 설계하고, 안정적인 구축 및 운영을
                        지원합니다. 기존 시스템을 클라우드로 이관(Migration) 할
                        때도 최소한의 다운타임으로 최적화된 환경을 제공합니다.
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className={'flex-col gap-20'}>
                <div className={'flex-col gap-20'}>
                  <div
                    onClick={() => goToSlideForOurService(2)}
                    className={`flex-row gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 2 ? 'active' : ''}`}
                  >
                    <div className="flex-row gap-8">
                      <div className="icon-40">
                        <AnimatedIcon
                          type={'collocation'}
                          active={ourServiceActiveIndex === 1}
                        />
                      </div>
                      <div className="btnText flex-col gap-8 justify-center">
                        <div className="main">
                          <span>코로케이션</span>
                        </div>
                        <div className="sub">
                          <span>Colocation</span>
                        </div>
                      </div>
                    </div>
                    <div className="numText">
                      <span>02</span>
                    </div>
                  </div>
                  <div className="contentImgWrap">
                    <img src={corocationImg} alt="" />
                    {/*<div className="moreBtn">*/}
                    {/*  <span>VIEW MORE</span>*/}
                    {/*</div>*/}
                    <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                      <div className="textWrap">
                        <span>02</span>
                      </div>
                      <div className="arcSvg positionLB">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="arcSvg positionRT">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="contentTextWrap pl-12 flex-col gap-16">
                    <div className="title">
                      <span>코로케이션</span>
                    </div>
                    <div className="description">
                      <span>
                        고객장비의 안정적인 운영을 위한 최적의 데이터센터 환경
                        제공, 24/7 모니터링, 이중화 전력 · 네트워크 인프라로
                        무중단 서비스를 지원 합니다.
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className={'flex-col gap-20'}>
                <div className={'flex-col gap-20'}>
                  <div
                    onClick={() => goToSlideForOurService(3)}
                    className={`flex-row gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 3 ? 'active' : ''}`}
                  >
                    <div className="flex-row gap-8">
                      <div className="icon-40">
                        <AnimatedIcon
                          type={'hosting'}
                          active={ourServiceActiveIndex === 2}
                        />
                      </div>
                      <div className="btnText flex-col gap-8 justify-center">
                        <div className="main">
                          <span>서버호스팅</span>
                        </div>
                        <div className="sub">
                          <span>Server Hosting</span>
                        </div>
                      </div>
                    </div>
                    <div className="numText">
                      <span>03</span>
                    </div>
                  </div>
                  <div className="contentImgWrap userSliderItemImg">
                    <img src={hostingImg} alt="" />
                    {/*<div className="moreBtn">*/}
                    {/*  <span>VIEW MORE</span>*/}
                    {/*</div>*/}
                    <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                      <div className="textWrap">
                        <span>03</span>
                      </div>
                      <div className="arcSvg positionLB">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="arcSvg positionRT">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="contentTextWrap pl-12 userSliderItemText flex-col gap-16">
                    <div className="title">
                      <span>서버호스팅</span>
                    </div>
                    <div className="description">
                      <span>
                        고객의 서비스 특성과 규모에 맞춘 전용 서버 제공으로
                        안정적인 운영 환경을 지원합니다.
                        <br />
                        네트워크, 보안 장애 대응까지 통합 관리하여 효율적인
                        인프라 운영을 가능하게 합니다.
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide className={'flex-col gap-20'}>
                <div className={'flex-col gap-20'}>
                  <div
                    onClick={() => goToSlideForOurService(1)}
                    className={`flex-row gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 1 ? 'active' : ''}`}
                  >
                    <div className="flex-row gap-8">
                      <div className="icon-40">
                        <AnimatedIcon
                          type={'streaming'}
                          active={ourServiceActiveIndex === 3}
                        />
                      </div>
                      <div className="btnText flex-col gap-8 justify-center">
                        <div className="main">
                          <span>CDN / 와우자</span>
                        </div>
                        <div className="sub">
                          <span>Content Delivery Network</span>
                        </div>
                      </div>
                    </div>
                    <div className="numText">
                      <span>04</span>
                    </div>
                  </div>
                  <div className="contentImgWrap">
                    <img src={cdnImg} alt="" />
                    {/*<div className="moreBtn">*/}
                    {/*  <span>VIEW MORE</span>*/}
                    {/*</div>*/}
                    <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                      <div className="textWrap">
                        <span>04</span>
                      </div>
                      <div className="arcSvg positionLB">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="arcSvg positionRT">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="21"
                          viewBox="0 0 28 21"
                          fill="none"
                        >
                          <path
                            d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="contentTextWrap pl-12 flex-col gap-16">
                    <div className="title">
                      <span>CDN / 와우자</span>
                    </div>
                    <div className="description">
                      <span>
                        분산된 CDN 인프라를 통해 대용량 트래픽에도 끊김 없는
                        콘텐츠 전송을 제공합니다.
                        <br />
                        빠른 응답 속도와 안정성을 통해 사용자 만족도를 높입니다.
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
            <div className="swiperNav flex-col gap-16 ">
              <div
                onClick={() => goToSlideForOurService(0)}
                className={`flex-row cloudGroup gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 0 ? 'active' : ''}`}
              >
                <div className="flex-row gap-8">
                  <div className="icon-40">
                    <AnimatedIcon
                      type="cloud"
                      active={ourServiceActiveIndex === 0}
                    />
                  </div>
                  <div className="btnText flex-col gap-8 justify-center">
                    <div className="main">
                      <span>클라우드 설계 구축 및 이관</span>
                    </div>
                    <div className="sub">
                      <span>
                        Cloud Architecture Design,
                        <br />
                        Deployment, and Migration
                      </span>
                    </div>
                  </div>
                </div>
                <div className="numText">
                  <span>01</span>
                </div>
              </div>

              <div
                onClick={() => goToSlideForOurService(1)}
                className={`flex-row collocationGroup gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 1 ? 'active' : ''}`}
              >
                <div className="flex-row gap-8">
                  <div className="icon-40">
                    <AnimatedIcon
                      type={'collocation'}
                      active={ourServiceActiveIndex === 1}
                    />
                  </div>
                  <div className="btnText flex-col gap-8 justify-center">
                    <div className="main">
                      <span>코로케이션</span>
                    </div>
                    <div className="sub">
                      <span>Colocation</span>
                    </div>
                  </div>
                </div>
                <div className="numText">
                  <span>02</span>
                </div>
              </div>
              <div
                onClick={() => goToSlideForOurService(2)}
                className={`flex-row serverGroup gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 2 ? 'active' : ''}`}
              >
                <div className="flex-row gap-8">
                  <div className="icon-40">
                    <AnimatedIcon
                      type={'hosting'}
                      active={ourServiceActiveIndex === 2}
                    />
                  </div>
                  <div className="btnText flex-col gap-8 justify-center">
                    <div className="main">
                      <span>서버호스팅</span>
                    </div>
                    <div className="sub">
                      <span>Server Hosting</span>
                    </div>
                  </div>
                </div>
                <div className="numText">
                  <span>03</span>
                </div>
              </div>
              <div
                onClick={() => goToSlideForOurService(3)}
                className={`flex-row streamingGroup gap-8 px-24 py-24  swiperNavBtn ${ourServiceActiveIndex === 3 ? 'active' : ''}`}
              >
                <div className="flex-row gap-8">
                  <div className="icon-40">
                    <AnimatedIcon
                      type={'streaming'}
                      active={ourServiceActiveIndex === 3}
                    />
                  </div>
                  <div className="btnText flex-col gap-8 justify-center">
                    <div className="main">
                      <span>CDN / 와우자</span>
                    </div>
                    <div className="sub">
                      <span>Content Delivery Network / Wowza</span>
                    </div>
                  </div>
                </div>
                <div className="numText">
                  <span>04</span>
                </div>
              </div>
            </div>
          </div>
          <div className="indicaterGageWrap flex-col justify-center  ">
            <div className="gird flex-col">
              <div
                onMouseMove={ourServiceHandleSloganMouseMove}
                onMouseLeave={ourServiceHandleSloganMouseLeave}
                className="gageRail"
                onClick={ourServiceHandleSloganClick} // 클릭 이벤트 추가
              >
                <div
                  style={{
                    maxWidth: ourServiceProgressPercent + '%',
                  }}
                  className="gage"
                ></div>
                {ourServiceTooltipVisible && (
                  <div
                    className="tooltip"
                    style={{
                      left: `${ourServiceTooltipPercent}%`,
                    }}
                  >
                    {Math.round(ourServiceTooltipPercent)}%
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="bannerSection  py-40 flex-col justify-center align-center"
      >
        <div className="bannerImage">
          <img src={bannerImg} alt="" />
        </div>
        <div className="grid ">
          <div className="titleWrap flex-col gap-24">
            <div className="main">
              <span>저희 서비스가 궁금하신가요?</span>
            </div>
            <div className="description">
              <span>디엔에이클라우드의 다양한 프로젝트를 소개합니다</span>
            </div>
            <Link to={'/contact'}>
              <div className="primaryBtn44">
                <span>문의하기</span>
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="portfolioSection  py-144 flex-col justify-center align-center"
      >
        <div className="grid flex-col gap-48">
          <div className="titleWrap flex-col gap-24">
            <div className="accent flex-row gap-8">
              <span>고객 사례</span>
            </div>
            <div className="title">
              <span>
                신규 서비스 구축 및 CSP 전환사례를 통해
                <br />
                <strong> 검증된 전문성</strong>
              </span>
            </div>
          </div>
          <div className="contentWrap flex-row ">
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(1);
              }}
              className={`hoverCard flex-col pb-4 pr-16 gap-16 ${portfolioActiveIndex === 1 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="mainImgWrap">
                  <img src={portfolioImg1} alt="" />
                </div>
                <div className="logoImgWrap flex">
                  <img src={deliveryLogo} alt="" />
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>01</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="textWrap justify-between pl-12 flex-row gap-16">
                <div className="titleWrap">
                  <span>
                    배달서비스공제조합, 배달 라이더를 위한 보험회사, 비영리법인
                  </span>
                </div>
              </div>
            </div>
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(2);
              }}
              className={`hoverCard flex-col pb-4 pr-16 gap-16 ${portfolioActiveIndex === 2 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="mainImgWrap">
                  <img src={portfolioImg2} alt="" />
                </div>
                <div className="logoImgWrap kisa flex-col gap-12">
                  <img src={kisaLogo} alt="" />
                  <div className="logoCaption">
                    <span>전자문서유통허브 클라우드 서비스</span>
                  </div>
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>02</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="textWrap justify-between pl-12 flex-row gap-16">
                <div className="titleWrap">
                  <span>친환경 디지털 세상을 위한 전자문서 플랫폼</span>
                </div>
              </div>
            </div>
            <div
              onMouseOver={() => {
                setPortfolioActiveIndex(3);
              }}
              className={`hoverCard flex-col pb-4 gap-16 ${portfolioActiveIndex === 3 ? 'active' : ''}`}
            >
              <div className="imgWrap">
                <div className="mainImgWrap">
                  <img src={portfolioImg3} alt="" />
                </div>
                <div className="logoImgWrap kisa flex-col gap-12">
                  <img src={kisaLogo} alt="" />
                  <div className="logoCaption">
                    <span>
                      KISA 가명정보 활용 지원체계 통합 운영 인프라 임차
                    </span>
                  </div>
                </div>
                <div className="numberWrap flex-col align-center justify-center px-24 py-20">
                  <div className="textWrap">
                    <span>03</span>
                  </div>
                  <div className="arcSvg positionLB">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.3916 0.647949H0.368164V20.148C0.69311 9.59647 9.19419 1.1313 19.7469 0.851003L27.3916 0.647949Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div className="arcSvg positionRT">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="21"
                      viewBox="0 0 28 21"
                      fill="none"
                    >
                      <path
                        d="M27.9092 0.938965H0.885742V20.439C1.21069 9.88749 9.71177 1.42232 20.2645 1.14202L27.9092 0.938965Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="textWrap justify-between pl-12 flex-row gap-16">
                <div className="titleWrap">
                  <span>가명처리 및 가명정보 결합을 지원하는 플랫폼</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        data-aos="fade"
        data-aos-delay="100"
        data-aos-offset="0"
        className="sloganSection  flex-col py-128 justify-center align-center"
      >
        <div className="grid flex-col gap-96">
          <div className="sloganWrap flex-col gap-48">
            <div className="sloganTitle">
              <span>
                <strong className={'strongA viewOne'}>Your </strong>
                <strong className={'strongB viewTwo'}>Trusted Partner</strong>
                <br />
                <strong className={'strongA viewThree'}>in</strong>
                <strong className={'strongC viewFour'}>
                  Digital Transformation
                </strong>
              </span>
            </div>
            <div className="description">
              <span>
                믿을 수 있는 파트너,
                <br />
                <strong>디엔에이클라우드와 함께</strong> 최상의 서비스를
                경험해보세요
              </span>
            </div>
          </div>
          <div className="ourStrongPointContents flex-col gap-48">
            <div className="swiperWrap">
              <Swiper
                onSwiper={(swiper) => (sloganSwiper.current = swiper)}
                className="sloganSwiper"
                onSlideChange={(swiper) =>
                  setSloganActiveIndex(swiper.realIndex)
                }
                modules={[Autoplay]}
                slidesPerView={slidesPerView}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                centeredSlides={true}
                loopAdditionalSlides={1}
                effect="creative"
                touchReleaseOnEdges={false}
                speed={800}
                spaceBetween={isDesktop ? 16 : 8}
                loop={true}
              >
                {sloganItem?.map((item, i) => {
                  return (
                    <SwiperSlide>
                      <div className="ourStrongCard py-40 px-24 flex-col gap-16">
                        <div className="subImg">
                          <img src={item.img} alt="" />
                        </div>
                        <div className="textWrap flex-col gap-16 ">
                          <div className="title pb-24">
                            <span>{item?.title}</span>
                          </div>
                          <div className="description pb-24">
                            <span>
                              {item.mainDescription}
                              <br />
                              {item.subDescription}
                            </span>
                          </div>
                          <Link to={'contact'}>
                            <div className="contactUsBtn flex-row gap-8 align-center">
                              <div className="btnText">
                                <span>CONTACT US</span>
                              </div>
                              <div className="btnIcon flex-row align-center justify-center">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="21"
                                  height="20"
                                  viewBox="0 0 21 20"
                                  fill="none"
                                >
                                  <path
                                    d="M1.58203 9.82861C1.58203 11.0105 1.81482 12.1808 2.26712 13.2728C2.71941 14.3647 3.38234 15.3568 4.21807 16.1926C5.0538 17.0283 6.04595 17.6912 7.13788 18.1435C8.22981 18.5958 9.40013 18.8286 10.582 18.8286C11.7639 18.8286 12.9343 18.5958 14.0262 18.1435C15.1181 17.6912 16.1103 17.0283 16.946 16.1926C17.7817 15.3568 18.4447 14.3647 18.8969 13.2728C19.3492 12.1808 19.582 11.0105 19.582 9.82861C19.582 7.44166 18.6338 5.15248 16.946 3.46465C15.2582 1.77682 12.969 0.828613 10.582 0.828613C8.19508 0.828613 5.9059 1.77682 4.21807 3.46465C2.53024 5.15248 1.58203 7.44166 1.58203 9.82861Z"
                                    fill="#1681FC"
                                    stroke="#1681FC"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M7.58203 9.82861H13.582"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M10.582 6.82861L13.6401 9.82861L10.582 12.8286"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
                {/*<Swiper*/}
                {/*  onSwiper={(swiper) => (sloganSwiper.current = swiper)}*/}
                {/*  className={'sloganSwiper'}*/}
                {/*  onSlideChange={(swiper) =>*/}
                {/*    setSloganActiveIndex(swiper.realIndex)*/}
                {/*  }*/}
                {/*  modules={[Autoplay]}*/}
                {/*  slidesPerView={3}*/}
                {/*  autoplay={true}*/}
                {/*  autoplaySpeed={800}*/}
                {/*  centeredSlides={true}*/}
                {/*  loopAdditionalSlides={1}*/}
                {/*  effect="creative"*/}
                {/*  touchReleaseOnEdges={false}*/}
                {/*  speed={800}*/}
                {/*  spaceBetween={16}*/}
                {/*  loop={true}*/}
                {/*>*/}
              </Swiper>
            </div>
            <div className="mainIndicaterWrap flex-col align-center justify-center px-40">
              <div className="mainIndicater flex-row gap-8">
                <div className="stickWrap flex-row gap-8 align-center">
                  <div
                    onClick={() => goToSlideForSlogan(0)}
                    className={`stick ${sloganActiveIndex === 0 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlideForSlogan(1)}
                    className={`stick ${sloganActiveIndex === 1 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlideForSlogan(2)}
                    className={`stick ${sloganActiveIndex === 2 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlideForSlogan(3)}
                    className={`stick ${sloganActiveIndex === 3 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlideForSlogan(4)}
                    className={`stick ${sloganActiveIndex === 4 ? 'active' : ''}`}
                  ></div>
                  <div
                    onClick={() => goToSlideForSlogan(5)}
                    className={`stick ${sloganActiveIndex === 5 ? 'active' : ''}`}
                  ></div>
                </div>
                <div className="icon"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
